import { ESizeType, type IMedia, type TFirstPaintOptions } from '@cian/frontend-newbuilding-carousel-component';

export const firstPaintOptions: TFirstPaintOptions = {
  defaultControls: [],
  draggable: true,
  elementsWidth: {
    content: {
      type: ESizeType.PERCENT,
      width: 100,
    },
    gap: {
      type: ESizeType.PIXEL,
      width: 0,
    },
    leftEar: {
      type: ESizeType.PIXEL,
      width: 0,
    },
    rightEar: {
      type: ESizeType.PIXEL,
      width: 0,
    },
  },
  height: {
    type: ESizeType.PERCENT,
    value: 100,
  },
  slidesToShow: 1,
};

export const mediaSettings: IMedia[] = [
  {
    maxWidth: Infinity,
    minWidth: 1,
    settings: {
      defaultControls: [],
      draggable: true,
      elementsWidth: {
        content: {
          type: ESizeType.PERCENT,
          width: 100,
        },
        gap: {
          type: ESizeType.PIXEL,
          width: 0,
        },
        leftEar: {
          type: ESizeType.PIXEL,
          width: 0,
        },
        rightEar: {
          type: ESizeType.PIXEL,
          width: 0,
        },
      },
      height: {
        type: ESizeType.PERCENT,
        value: 100,
      },
      slidesToScroll: 1,

      slidesToShow: 1,
    },
  },
];
